<div class="conversation-list">
  <button class="conversation-list__new-chat" (click)="onNewChat()" type="button">
    + {{ 'assistantPage.newChat' | translate }}
  </button>

  @if (deleteError) {
    <div class="conversation-list__error">
      <span>{{ 'assistantPage.list.deleteError' | translate }}</span>
      <button type="button" (click)="dismissDeleteError()" aria-label="{{ 'assistantPage.list.dismissAria' | translate }}">✕</button>
    </div>
  }

  @if (loading) {
    <div class="conversation-list__loading">{{ 'assistantPage.list.loading' | translate }}</div>
  }

  @if (!loading && groupedConversations.length === 0) {
    @if (loadError) {
      <div class="conversation-list__error">{{ 'assistantPage.list.loadError' | translate }}</div>
    } @else {
      <div class="conversation-list__empty">{{ 'assistantPage.list.empty' | translate }}</div>
    }
  }

  @if (!loading) {
    @for (group of groupedConversations; track group.label) {
      <div class="conversation-list__group">
        <span class="conversation-list__group-label">{{ group.label | translate }}</span>
        @for (item of group.items; track trackById($index, item)) {
          <div
            class="conversation-list__item"
            [class.active]="item.id === activeConversationId"
            role="button"
            tabindex="0"
            [attr.aria-current]="item.id === activeConversationId ? 'true' : null"
            (click)="onSelect(item)"
            (keydown.enter)="onSelect(item)"
            (keydown.space)="onSelect(item); $event.preventDefault()">
            <div class="conversation-list__item-text">
              <span class="conversation-list__item-title">{{ item.title }}</span>
              <span class="conversation-list__item-preview">{{ item.lastMessagePreview }}</span>
            </div>
            <button
              class="conversation-list__item-delete"
              (click)="onDelete(item, $event)"
              type="button"
              aria-label="{{ 'assistantPage.list.deleteAria' | translate }}">
              🗑
            </button>
          </div>
        }
      </div>
    }
  }
</div>
